
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import GlobalButton from './GlobalButton';
import FilterIcon from 'assets/svgs/FilterIcon';
import { TertiaryColor, maxTablet, maxWidth, maxWidth1300, midMobile, primaryActiveColor, primaryColor, primaryFont, retina, scrollbarTransparent, wMedium } from 'constants/utilsStyles';
import DropDownButtonGlobal from './DropDownButtonGlobal';
import ArrowDownIcon from 'assets/svgs/ArrowDownIcon';
import CrossIcon from 'assets/svgs/CrossIcon';
import ArrowUpIcon from 'assets/svgs/ArrowUpIcon';
import PersonalityTypeFilters from 'modules/Audience/Components/Filters/PersonalityTypeFilters';
import StatusFilters from 'modules/Audience/Components/Filters/StatusFilters';
import OrganizationsFilters from 'modules/Audience/Components/Filters/OrganizationsFilters';
import DesignationsFilters from 'modules/Audience/Components/Filters/DesignationsFilters';
import { getQueryListId } from 'utils';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { resetListContactsResetAllAction, setListContactsFiltersListIdAction } from 'modules/Audience/Actions/contactsFiltersActions';
import classNames from 'classnames';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  .disabled{
    opacity: 0.5;
    pointer-events: none;
  }
  .filter-btn {
    &.iconModeWrapper {
      padding: 8px 10px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        padding: 5px 10px;
      }
      @media all and (max-width: ${maxWidth1300}) {
        padding: 6px 8px 5px;
      }
    }
    box-shadow: 0px 2px 17px rgba(0, 0, 0, 0.14);
    svg {
      width: 18px;
      min-width: 18px;
      height: 18px;
      path {
        fill: #7E7E7E;
      }
    }
  }
  &.filtersSelected {
    .filter-btn {
      background-color: #DEF6E6;
      border: 1px solid #DADADA;
      &.iconModeWrapper {
        padding: 8px 10px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          padding: 5px 10px;
        }
        @media all and (max-width: ${maxWidth1300}) {
          padding: 6px 8px 5px;
        }
      }
      box-shadow: 0px 2px 17px rgba(0, 0, 0, 0.14);
      svg {
        width: 18px;
        min-width: 18px;
        height: 18px;
        path {
        fill: #1EC252;
      }
      }
    }
  }
  .filters-div > div {
    margin-left: 10px;
    @media all and (max-width: ${maxTablet}) {
      margin-left: 6px;
    }
  }
  .filters-div {
    display: flex;
    align-items: center;
    .dropdown-global-btn {
      svg {
        height: 11px;
        width: 11px;
        min-width: 11px;
      }
      .arrow-up-icon {
        margin-bottom: 3px;
      }
    }
  }
  @media all and (max-width: ${midMobile}) {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    ${scrollbarTransparent};
  }
  .primary-global-btn {
    padding: 7px 15px;
  }
  .clear-all-text {
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16px;
    line-height: 18px;
    color: #7E7E7E;
    cursor: pointer;
    margin-left: 10px;
    @media all and (max-width: ${maxTablet}) {
      margin-left: 6px;
    }
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
type Props = {
  onApplyFilters?: () => void;
  applied?: boolean;
  onClearFilters?: () => void;
  fromList?: boolean;
} & typeof defaultProps;

const defaultProps = {
};

export type DropDownIconsType = {
  rightIcon: JSX.Element;
  bgColor: string;
  borderColor: string;
  fColor: string;
  separatorColor: string;
};

export type FiltersToggleType = {
  rightIcon: JSX.Element;
  bgColor: string;
  borderColor: string;
  iconMode: boolean;
}


const ToggleFilterButtonGlobal = (props: Props) => {
  const { onApplyFilters, applied, onClearFilters, fromList } = props;
  const [toggleFilter, setToggleFilter] = useState(false);
  const reducerListId = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.listId);
  const listDetailsSearchTerm = useSelector((state: RootState) => state.audienceListDetailsReducerV2.searchTerm);
  const globalStatusSelected = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.selectedFilters.status);
  const globalPersonalitySelected = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.selectedFilters.personalityType);
  const globalOrganizationsSelected = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.selectedFilters.organization);
  const globalDesignationsSelected = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.selectedFilters.designation);
  const listStatusSelected = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.selectedFilters.status);
  const listPersonalitySelected = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.selectedFilters.personalityType);
  const listOrganizationsSelected = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.selectedFilters.organization);
  const listDesignationsSelected = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.selectedFilters.designation);
  const {
    status: globalStatusFilter,
    designation: globalDesignationFilter,
    organization: globalOrganizationFilter,
    personalityType: globalPersonalityTypeFilter
  } = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.appliedFilters);
  const {
    status: listStatusFilter,
    designation: listDesignationFilter,
    organization: listOrganizationFilter,
    personalityType: listPersonalityTypeFilter
  } = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters);
  const queryListId = getQueryListId()?.toString();
  const noFilterSelectedInGlobal: boolean = !(globalStatusSelected?.length !== 0 || globalPersonalitySelected?.length !== 0 || globalOrganizationsSelected?.length !== 0 || globalDesignationsSelected?.length !== 0);
  const noFilterSelectedInList: boolean = !(listStatusSelected?.length !== 0 || listPersonalitySelected?.length !== 0 || listOrganizationsSelected?.length !== 0 || listDesignationsSelected?.length !== 0);
  const globalFiltersApplied: boolean = (
    globalStatusFilter.length !== 0 ||
    globalDesignationFilter.length !== 0 ||
    globalOrganizationFilter.length !== 0 ||
    globalPersonalityTypeFilter.length !== 0
  );
  const listFiltersApplied: boolean = (
    listStatusFilter.length !== 0 ||
    listDesignationFilter.length !== 0 ||
    listOrganizationFilter.length !== 0 ||
    listPersonalityTypeFilter.length !== 0
  );
  const ToggleFn = (prevState: boolean) => setToggleFilter(!prevState);

  const filterBtn: FiltersToggleType = {
    rightIcon: <FilterIcon fillColor={primaryColor} />,
    bgColor: '#fff',
    borderColor: '#fff',
    iconMode: true,
  };

  const crossBtn: FiltersToggleType = {
    rightIcon: <CrossIcon fillColor={primaryColor} />,
    bgColor: '#fff',
    borderColor: '#fff',
    iconMode: true,
  };

  // const clearBtn = {
  //   rightIcon: <CrossIcon fillColor={primaryColor} />,
  //   bgColor: '#fff',
  //   fColor: TertiaryColor,
  //   borderColor: '#DADADA',
  //   separatorColor: '#DADADA',
  //   iconMode: false,
  // };

  const CompanyFilterData: DropDownIconsType = {
    rightIcon: <ArrowDownIcon />,
    bgColor: '#fff',
    borderColor: '#DADADA',
    fColor: '#7E7E7E',
    separatorColor: TertiaryColor,
  };

  const CompanyActiveFilterData: DropDownIconsType = {
    rightIcon: <ArrowUpIcon />,
    bgColor: primaryActiveColor,
    borderColor: primaryColor,
    fColor: primaryColor,
    separatorColor: TertiaryColor,
  };

  const CompanySelectedFilterData: DropDownIconsType = {
    rightIcon: <ArrowDownIcon />,
    bgColor: primaryActiveColor,
    borderColor: primaryColor,
    fColor: primaryColor,
    separatorColor: TertiaryColor,
  };

  const primaryBtn = {
    bgColor: primaryColor,
    fColor: '#fff',
    borderColor: primaryColor,
    noSeparator: true,
  };

  useEffect(() => {
    if (queryListId && queryListId !== reducerListId) {
      resetListContactsResetAllAction();
      setListContactsFiltersListIdAction(queryListId?.toString());
    }
  }, []);

  console.log(globalFiltersApplied || listFiltersApplied);


  return (
    <Wrapper className={classNames('toggle-filter-btn-global', {
      filtersSelected: globalFiltersApplied || listFiltersApplied,
    })}>
      <GlobalButton globalButtonData={toggleFilter ? crossBtn : filterBtn} btnClassName='filter-btn' onClick={() => ToggleFn(toggleFilter)} title='Filters' />
      {toggleFilter ? (
        <div className='filters-div'>
          <OrganizationsFilters listDetailsSearchTerm={listDetailsSearchTerm} CompanyFilterData={CompanyFilterData} CompanyActiveFilterData={CompanyActiveFilterData} CompanySelectedFilterData={CompanySelectedFilterData} />
          <DesignationsFilters listDetailsSearchTerm={listDetailsSearchTerm} CompanyFilterData={CompanyFilterData} CompanyActiveFilterData={CompanyActiveFilterData} CompanySelectedFilterData={CompanySelectedFilterData} />
          <PersonalityTypeFilters listDetailsSearchTerm={listDetailsSearchTerm} CompanyFilterData={CompanyFilterData} CompanyActiveFilterData={CompanyActiveFilterData} CompanySelectedFilterData={CompanySelectedFilterData} />
          <StatusFilters listDetailsSearchTerm={listDetailsSearchTerm} CompanyFilterData={CompanyFilterData} CompanyActiveFilterData={CompanyActiveFilterData} CompanySelectedFilterData={CompanySelectedFilterData} />
          <GlobalButton
            title="Apply"
            globalButtonData={primaryBtn}
            btnClassName={classNames('primary-global-btn', { disabled: fromList ? noFilterSelectedInList : noFilterSelectedInGlobal })}
            {...(onApplyFilters ? { onClick: onApplyFilters } : {})}
          />
          {applied ? (
            // <GlobalButton
            //   title="Clear"
            //   globalButtonData={clearBtn}
            //   btnClassName="import-global-btn"
            // />
            <span
              tabIndex={0}
              {...(onClearFilters ? { onClick: onClearFilters } : {})}
              role='button'
              className='clear-all-text'
            >
              Clear all
            </span>
          ) : null}

          {/* <DropDownButtonGlobal title="Personality" personality btnData={CompanyFilterData} activeBtnData={CompanyActiveFilterData} /> */}
          {/* <DropDownButtonGlobal title="Status" hideSearchBar btnData={CompanyFilterData} activeBtnData={CompanyActiveFilterData} /> */}
        </div>
      ) : null}
    </Wrapper>
  );
};
ToggleFilterButtonGlobal.defaultProps = defaultProps;
export default ToggleFilterButtonGlobal;